import React from "react";

const RefundPolicy = () => {
  return (
    <div className="p-6 w-full  min-h-screen mx-auto bg-white rounded-lg shadow-lg">
      <h1 className="text-2xl font-bold mb-4">Refund Policy</h1>
      <p className="mb-4">
        Currently, we do not offer any refunds for our products or services. All sales are final.
      </p>

      <h2 className="text-xl font-semibold mb-2">Contact Us</h2>
      <p>
        If you have any questions regarding our policy, please contact us at <strong>support@businessbasket.in </strong>.
      </p>
    </div>
  );
};

export default RefundPolicy;
